<template>
    <el-row class="top">
        <el-col :span="12">
            <div class="title_f">知夏门诊管理平台</div>
        </el-col>
        <el-col class="top_right" :span="12">
            <div class="top_icon mrlr10">
                <el-icon>
                    <Share/>
                </el-icon>
            </div>
            <div class="top_icon mrlr10">
                <el-icon>
                    <bell-filled/>
                </el-icon>
            </div>
            <el-dropdown>
                <el-avatar class="mrlr10" :size="36" :src="headImg"></el-avatar>
                <template #dropdown>
                    <el-dropdown-menu>
                        <el-dropdown-item @click="changeData('personal')">个人中心</el-dropdown-item>
                        <el-dropdown-item @click="logout()">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </template>
            </el-dropdown>
        </el-col>
    </el-row>
</template>

<script>
import baseConfig from '@/api/config'

export default {
    data() {
        return {
            headImg: "",
            sysName: "",
            userInfo: null,
        }
    },
    created() {
        // console.log(window.sessionStorage.getItem("user"));
        this.userInfo = JSON.parse(window.sessionStorage.getItem("user"));
        this.headImg = baseConfig.tencentCosUrl + this.userInfo.avatar;
        this.doctorInfo = JSON.parse(window.sessionStorage.getItem("doctorInfo"));
        if (this.doctorInfo !== null && this.doctorInfo !== undefined && this.doctorInfo !== "") {
            if (this.doctorInfo.headPic === null || this.doctorInfo.headPic === "" || this.doctorInfo.headPic === undefined) {
                this.headImg = baseConfig.tencentCosUrl + "/tcmmsPic/profile.jpg";
            } else {
                this.headImg = baseConfig.tencentCosUrl + this.doctorInfo.headPic;
            }
        }
        this.sysName = this.userInfo.nickName;
        // console.log(this.sysName);
    },
    methods: {
        changeData(name) {
            this.$router.push({path: '/admin/' + name});
            this.$store.state.adminleftnavnum = name; //设置左侧导航2-2 active
        },
        // 退出登录
        logout() {
            window.sessionStorage.clear();
            this.$router.push({path: '/login'});
        },
    }
}
</script>

<style scoped lang="scss">
    @import "@/assets/styles/admin.scss";
</style>
